class DailyStylePicks extends HTMLElement {
  connectedCallback() {
    const section = this.closest('[data-daily-style-picks]');
    if (!section) return;

    const limit = Number(section.dataset.dailyLimit || 15);
    const items = Array.from(this.querySelectorAll('[data-daily-style-item]'));
    if (!items.length) return;

    const seed = this.getDailySeed();
    const selected = this.selectDailyItems(items, limit, seed);

    items.forEach((item) => {
      item.classList.add('is-daily-hidden');
      item.hidden = true;
      item.style.order = '';
    });

    selected.forEach((item, index) => {
      item.classList.remove('katredar-daily-picks__item--initial-hidden', 'is-daily-hidden');
      item.hidden = false;
      item.style.order = String(index + 1);
    });
  }

  getDailySeed() {
    const formatter = new Intl.DateTimeFormat('en-CA', {
      day: '2-digit',
      month: '2-digit',
      timeZone: 'Europe/Istanbul',
      year: 'numeric',
    });
    const dateKey = formatter.format(new Date());
    let seed = 0;

    for (let index = 0; index < dateKey.length; index += 1) {
      seed = Math.imul(seed ^ dateKey.charCodeAt(index), 2654435761);
    }

    return seed >>> 0;
  }

  selectDailyItems(items, limit, seed) {
    const uniqueItems = [];
    const seenProducts = new Set();

    items.forEach((item) => {
      const productId = item.dataset.productId;
      if (!productId || seenProducts.has(productId)) return;
      seenProducts.add(productId);
      uniqueItems.push(item);
    });

    const groups = new Map();
    uniqueItems.forEach((item) => {
      const key = item.dataset.sourceKey || 'default';
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(item);
    });

    const selected = [];
    const selectedProducts = new Set();
    const rng = this.createRandom(seed);
    const groupEntries = this.shuffle(Array.from(groups.entries()), rng);

    groupEntries.forEach(([, groupItems]) => {
      const shuffledGroup = this.shuffle(groupItems, rng);
      shuffledGroup.slice(0, 2).forEach((item) => {
        if (selected.length >= limit) return;
        if (selectedProducts.has(item.dataset.productId)) return;
        selectedProducts.add(item.dataset.productId);
        selected.push(item);
      });
    });

    const remaining = this.shuffle(uniqueItems, rng);
    remaining.forEach((item) => {
      if (selected.length >= limit) return;
      if (selectedProducts.has(item.dataset.productId)) return;
      selectedProducts.add(item.dataset.productId);
      selected.push(item);
    });

    return selected;
  }

  createRandom(seed) {
    let value = seed || 1;

    return () => {
      value |= 0;
      value = (value + 0x6d2b79f5) | 0;
      let result = Math.imul(value ^ (value >>> 15), 1 | value);
      result = (result + Math.imul(result ^ (result >>> 7), 61 | result)) ^ result;
      return ((result ^ (result >>> 14)) >>> 0) / 4294967296;
    };
  }

  shuffle(items, rng) {
    const shuffled = items.slice();

    for (let index = shuffled.length - 1; index > 0; index -= 1) {
      const swapIndex = Math.floor(rng() * (index + 1));
      [shuffled[index], shuffled[swapIndex]] = [shuffled[swapIndex], shuffled[index]];
    }

    return shuffled;
  }
}

if (!customElements.get('daily-style-picks')) {
  customElements.define('daily-style-picks', DailyStylePicks);
}
